import { useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Search } from "lucide-react";

const REASON = { no_teacher: "Aucun enseignant assigné", dead_teacher_id: "Enseignant introuvable (compte supprimé ou id invalide)" };

// Read-only report (master admin): nothing here writes data. Reassign teachers from the Classes page.
export function MissingTeachersReport() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { setData(await api.get("/admin/classes-missing-teacher")); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-8 max-w-3xl rounded-lg border border-border bg-card p-5 space-y-3" data-testid="missing-teachers-card">
      <h3 className="font-heading font-bold">Classes avec un enseignant manquant</h3>
      <p className="text-sm text-muted-foreground">Rapport en lecture seule : classes sans enseignant valide et cours de l'emploi du temps dont l'enseignant n'existe plus. Réassignez ensuite depuis la page Classes.</p>
      <Button variant="outline" onClick={load} disabled={busy} data-testid="missing-teachers-load-btn"><Search className="h-4 w-4 mr-1" />{data ? "Actualiser" : "Afficher le rapport"}</Button>
      {data && (data.classes.length === 0 ? <p className="text-sm text-emerald-700" data-testid="missing-teachers-none">Toutes les classes ont des enseignants valides.</p> : (
        <div className="space-y-2" data-testid="missing-teachers-result">
          <p className="text-xs text-muted-foreground">{data.totals.classes_without_valid_teacher} classe(s) sans enseignant valide · {data.totals.dead_schedule_teacher_ids} identifiant(s) d'enseignant introuvable(s) dans les emplois du temps</p>
          <ul className="divide-y divide-border rounded border border-border text-sm">
            {data.classes.map((c) => (
              <li key={c.class_id} className="p-3" data-testid={`missing-teacher-${c.class_id}`}>
                <p className="font-semibold">{c.class_name} <span className="font-normal text-muted-foreground">({c.grade_level || "—"})</span>{c.demo_class && <span className="ml-2 text-[10px] rounded bg-muted px-1.5 py-0.5">démo</span>}</p>
                {c.reason && <p className="text-red-700">{REASON[c.reason]}{c.teacher_name ? ` — nom saisi : ${c.teacher_name}` : ""}</p>}
                {c.dead_slot_teachers.map((d) => (
                  <p key={d.teacher_id} className="text-amber-800 text-xs">{d.slots} cours avec un enseignant introuvable ({d.teacher_id.slice(-8)}){d.subjects.length ? ` : ${d.subjects.join(", ")}` : ""}</p>
                ))}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
